import { useEffect, useState } from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from "@mui/material";
import { getReviewerResponses360 } from "../axios/axiosFunctions";

const ANSWER_LABELS = {
  unable: "Unable to Respond",
  notConfident: "Not Confident",
  somewhat: "Somewhat Confident",
  confident: "Confident",
  very: "Very Confident",
};

const ANSWER_COLORS = {
  unable: "#9e9e9e",
  notConfident: "#f44336",
  somewhat: "#ff9800",
  confident: "#2196f3",
  very: "#4caf50",
};

const ViewResponsesDialog = ({ open, onClose, reviewerId, reviewerName, ownerId, slug }) => {
  const [blocks, setBlocks] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && reviewerId && ownerId && slug) {
      setLoading(true);
      getReviewerResponses360(slug, reviewerId, ownerId)
        .then((data) => {
          setBlocks(data?.blocks || []);
        })
        .finally(() => setLoading(false));
    }
  }, [open, reviewerId, ownerId, slug]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold", color: "#0F5385" }}>
        Responses from {reviewerName}
      </DialogTitle>
      <DialogContent dividers>
        {loading && (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        )}
        {!loading && blocks.length === 0 && (
          <Typography color="text.secondary" py={2}>
            No responses found.
          </Typography>
        )}
        {!loading &&
          blocks.map((block) => (
            <Box key={block._id} sx={{ mb: 3 }}>
              <Box
                sx={{
                  backgroundColor: block.color || "#0F5385",
                  color: "#fff",
                  padding: "10px 16px",
                  borderRadius: "4px",
                  mb: 1.5,
                }}
              >
                <Typography variant="subtitle1" fontWeight={600}>
                  {block.name}
                </Typography>
              </Box>
              {block.questions.filter((q) => q.typeQ === "mo").length === 0 && (
                <Typography color="text.secondary" sx={{ pl: 1 }}>
                  No responses submitted for this section.
                </Typography>
              )}
              {block.questions
                .filter((q) => q.typeQ === "mo")
                .map((q, idx) => (
                  <Box
                    key={q._id}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1,
                      px: 1.5,
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <Typography variant="body2" sx={{ flex: 1, mr: 2 }}>
                      {idx + 1}. {q.text}
                    </Typography>
                    {q.answer ? (
                      <Chip
                        label={ANSWER_LABELS[q.answer] || q.answer}
                        size="small"
                        sx={{
                          backgroundColor: ANSWER_COLORS[q.answer] || "#757575",
                          color: "#fff",
                          fontWeight: 500,
                          minWidth: 140,
                        }}
                      />
                    ) : (
                      <Chip
                        label="No response"
                        size="small"
                        variant="outlined"
                        sx={{ minWidth: 140 }}
                      />
                    )}
                  </Box>
                ))}
              {block.questions
                .filter((q) => q.typeQ === "op")
                .map((q) => (
                  <Box key={q._id} sx={{ py: 1, px: 1.5 }}>
                    <Typography variant="body2" fontWeight={500} sx={{ mb: 0.5 }}>
                      Open-ended:
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        pl: 1,
                        fontStyle: q.answer ? "normal" : "italic",
                      }}
                    >
                      {q.answer || "No response"}
                    </Typography>
                  </Box>
                ))}
            </Box>
          ))}
      </DialogContent>
      <DialogActions sx={{ padding: "16px" }}>
        <Button onClick={onClose} variant="contained">
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewResponsesDialog;
